import './BracketTeam.css';

import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { MatchProps, MatchPropTypes } from '@models/Match';

import Team from '@views/Team';
import TeamSelector from '@views/TeamSelector';
import Score from '@views/Score';
import { Checkbox } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

export const getTemplateTeam = (from, teamGroup) => {
  if (!from || !from.group) return '';
  const rawGroup = String(from.group).toUpperCase();
  const resolvedGroup = teamGroup ? String(teamGroup).toUpperCase() : '';

  // Mejor tercero aún sin definir (pool de grupos posibles): solo "3", no "3CEFHI".
  if (from.pos === 3 && rawGroup.length > 1 && !resolvedGroup) {
    return `${from.pos}`;
  }

  const groupLabel =
    from.pos === 3 && rawGroup.length > 1 && resolvedGroup ? resolvedGroup : rawGroup;
  return `${from.pos}${groupLabel}`;
};

const TeamRowPlaceholder = () => (
  <span className="bracket-team-row-placeholder">
    <span className="bracket-team-placeholder-text">Selección</span>
    <span className="bracket-team-placeholder-flag" aria-hidden />
  </span>
);

const BracketTeam = ({
  team,
  score,
  from,
  side,
  winnerPosition,
  canEditScore,
  canEditTeam,
  showCheckbox,
  teams,
  isWinner,
  onChangeScore,
  onChangeTeam,
  onChangeWinner,
  teamGroup,
}) => {
  const nameContent = canEditTeam ? (
    <TeamSelector
      selected={team}
      teams={teams}
      onChange={onChangeTeam}
      teamAlign="right"
      placeholder={<TeamRowPlaceholder />}
    />
  ) : team ? (
    <Team code={team} align="right" />
  ) : (
    <TeamRowPlaceholder />
  );

  const scoreContent = canEditScore ? (
    <Score
      value={score}
      onChange={onChangeScore}
      placeholder="–"
    />
  ) : typeof score === 'number' && !Number.isNaN(score) ? (
    score
  ) : (
    <span className="bracket-score-placeholder">—</span>
  );

  const winnerNode = showCheckbox ? (
    canEditScore ? (
      <Checkbox checked={isWinner} onChange={onChangeWinner} />
    ) : isWinner ? (
      <CheckOutlined
        width={16}
        height={16}
        style={{ position: 'unset', color: '#1890ff' }}
      />
    ) : null
  ) : null;

  const winnerEdgeHome = winnerPosition === 'edge' && side === 'home';
  const winnerEdgeAway = winnerPosition === 'edge' && side === 'away';

  return (
    <div
      className={`participant ${canEditScore ? 'editable' : ''} ${
        canEditTeam ? 'selectable' : ''
      } participant--${side} participant--winner-${winnerPosition}`}
    >
      <div className="name">
        {winnerEdgeAway ? null : (
          <b
            className={`from${getTemplateTeam(from) ? '' : ' from--empty'}`}
          >
            {getTemplateTeam(from, teamGroup)}
          </b>
        )}
        {winnerEdgeHome ? <div className="winner-check winner-check--edge">{winnerNode}</div> : null}
        {nameContent}
        {winnerEdgeAway ? <div className="winner-check winner-check--edge">{winnerNode}</div> : null}
        {winnerEdgeAway ? (
          <b
            className={`from${getTemplateTeam(from) ? '' : ' from--empty'}`}
          >
            {getTemplateTeam(from, teamGroup)}
          </b>
        ) : null}
      </div>
      {winnerPosition === 'center' ? (
        <div className="winner-check">{winnerNode}</div>
      ) : null}
      <div className="score">{scoreContent}</div>
    </div>
  );
};

BracketTeam.displayName = 'BracketTeam';
BracketTeam.propTypes = {
  team: MatchPropTypes[MatchProps.TeamHome],
  score: MatchPropTypes[MatchProps.ScoreHome],
  from: MatchPropTypes[MatchProps.FromHome],
  side: PropTypes.oneOf(['home', 'away']),
  winnerPosition: PropTypes.oneOf(['center', 'edge']),
  canEditScore: PropTypes.bool,
  canEditTeam: PropTypes.bool,
  showCheckbox: PropTypes.bool,
  teams: PropTypes.arrayOf(PropTypes.string),
  isWinner: PropTypes.bool,
  onChangeScore: PropTypes.func,
  onChangeTeam: PropTypes.func,
  onChangeWinner: PropTypes.func,
  teamGroup: PropTypes.string,
};
BracketTeam.defaultProps = {
  side: 'home',
  winnerPosition: 'center',
  canEditScore: false,
  canEditTeam: false,
  isWinner: false,
  onChangeScore: noop,
  onChangeTeam: noop,
  onChangeWinner: noop,
  teamGroup: undefined,
};

export default BracketTeam;
